module.exports = __webpack_public_path__ + "img/-s-pic_product service_bfgnyl.f2c8b728.png";